import { render, staticRenderFns } from "./ContactInfoDefault.vue?vue&type=template&id=18400122"
import script from "./ContactInfoDefault.vue?vue&type=script&lang=ts"
export * from "./ContactInfoDefault.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18400122')) {
      api.createRecord('18400122', component.options)
    } else {
      api.reload('18400122', component.options)
    }
    module.hot.accept("./ContactInfoDefault.vue?vue&type=template&id=18400122", function () {
      api.rerender('18400122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfoDefault.vue"
export default component.exports